import React, {FunctionComponent} from 'react';
import Flag from 'react-flagkit';
import {ILocation} from '../../models/event/Location';
import Countries from '../../models/utils/Countries';
import IconOnline from '../icon/IconOnline';

const Location: FunctionComponent<ILocation> = ({online, country, city}) => {
  const cityStr = city ? `, ${city}` : '';
  const upperCaseCountry = country.toUpperCase();

  return (<>
    {!online &&
    <span className="flex items-center"><Flag country={upperCaseCountry}
      className="inline-block rounded-sm"/>&nbsp;{Countries.getName(upperCaseCountry)}{cityStr}</span>}
    {online && <span><IconOnline/> Online</span>}
  </>);
};

export default Location;
